var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1325_45187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.2978 18.7146V35.7188L29.9539 34.7296L27.5979 31.9036L17.6714 20.8681L26.0992 14.8799C30.3208 20.4522 30.454 19.0938 30.454 19.0938C30.454 19.0938 32.5393 15.9805 35.2146 18.6557L35.2978 18.7146Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8991 17.4297L32.4234 39.9841C32.3206 39.9943 32.2173 39.9995 32.114 39.9996H3.46387L14.8991 17.4297Z",
    fill: "#518EF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0993 14.8796L0.0351562 36.8163V7.92105C0.0351562 6.1623 1.46125 4.7373 3.21891 4.7373H22.2259C21.4097 6.14012 24.4359 7.04051 24.4359 8.78043C24.4359 10.5315 25.2732 13.4701 26.0993 14.8796Z",
    fill: "#28B446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2975 35.7188V36.8166C35.2975 38.47 34.0367 39.8295 32.4232 39.9848L17.7588 25.5134L21.3085 21.916L29.5012 30.0001L29.9536 30.447L35.2975 35.7188Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1966 17.9754L21.3088 21.9154L17.7591 25.5128L3.46398 39.9998H3.21891C1.46125 39.9998 0.0351562 38.5737 0.0351562 36.8161L22.2425 14.3115C22.6584 15.0235 25.5183 14.3026 26.0994 14.8793L27.1673 16.2521C27.6885 16.8078 24.7487 17.3855 25.1966 17.9754Z",
    fill: "#FFD837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.35168 17.7952C5.55418 17.7952 3.27832 15.5193 3.27832 12.7218C3.27832 9.9243 5.55418 7.64844 8.35168 7.64844C9.7059 7.64844 10.9796 8.17641 11.9384 9.13516L10.7621 10.3112C10.1177 9.66672 9.2616 9.3118 8.35168 9.3118C6.47137 9.3118 4.94176 10.8415 4.94176 12.7217C4.94176 14.602 6.47145 16.1316 8.35168 16.1316C9.94512 16.1316 11.2869 15.033 11.659 13.5534H8.35168V11.89H13.425V12.7217C13.425 15.5193 11.1492 17.7952 8.35168 17.7952Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2254 4.73734C23.8721 1.90516 26.9406 0 30.4536 0C35.7066 0 39.9649 4.25828 39.9649 9.51125C39.9649 10.8287 39.6965 12.0828 39.213 13.2239C38.7315 14.3563 38.0352 15.3847 37.1626 16.2523C36.4418 17.0186 35.7954 17.8281 35.2143 18.6554C31.4073 24.0791 30.4536 30.2714 30.4536 30.2714C30.4536 30.2714 29.4179 23.548 25.1962 17.9756C24.7482 17.3857 24.2647 16.8079 23.7436 16.2523H23.7446C23.1615 15.6736 22.6564 15.0212 22.2421 14.3117C21.4159 12.9023 20.9424 11.2622 20.9424 9.51117C20.9424 7.77133 21.4093 6.14008 22.2254 4.73734Z",
    fill: "#F14336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4539 4.44922C33.2493 4.44922 35.515 6.71617 35.515 9.51156C35.515 12.307 33.2493 14.5726 30.4539 14.5726C27.6586 14.5726 25.3916 12.307 25.3916 9.51156C25.3916 6.71617 27.6586 4.44922 30.4539 4.44922Z",
    fill: "#7E2D25"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1325_45187"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleMap);
export default __webpack_public_path__ + "static/media/google-map.a49487f88f391dac328f15d4117aa317.svg";
export { ForwardRef as ReactComponent };